import { css, styled } from "@mui/material";

export const SingleBlogPreviewContainer = styled("div")(
  ({ theme }) => css`
    margin: 4rem auto 0 auto;

    ${theme.breakpoints.up("mobile")} {
      padding: 0.5rem 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      width: ${theme.breakpoints.values.tablet}px;
    }

    ${theme.breakpoints.up("desktop")} {
      width: ${theme.breakpoints.values.desktop}px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      width: ${theme.breakpoints.values.desktopXl}px;
    }
  `,
);
